import { Topics, Types, Events } from '~/web-frontend-core/utils//enums/kafka';
import { Projects } from '~/web-frontend-core/utils//enums/projects';
/**
 * Первый уровень - Топик {
 *      второй - Тип события {
 *          третий - событие {
 *                  четвертый - событие активено для ['zenitbet', 'mobile_com', 'desktop', 'mobile_new', 'zenitbet_classic']
 *          }
 *      }
 * }
 */
const defaultSettings = Object.keys(Projects); // ['zenitbet', 'mobile_com', 'desktop', 'mobile_new', 'zenitbet_classic', 'cupis', 'mobile'];
const withoutClassic = defaultSettings.filter(projectName => projectName !== 'zenitbet_classic');
const mobileProjects = defaultSettings.filter(projectName => ['mobile', 'mobile_com', 'mobile_new'].includes(projectName));
const cupisProjects = defaultSettings.filter(projectName => ['mobile', 'cupis'].includes(projectName));
export const EventsMap = {
    [Topics.baseIdentityActions]: {
        [Types.launch]: {
            [Events.sessionStart]: [Projects.zenitbet, Projects.mobile_com, Projects.desktop, Projects.mobile_new],
        },
        [Types.registration]: {
            [Events.gotoRofit]: defaultSettings,
            [Events.regStart]: defaultSettings,
            [Events.enteredCharInReg]: withoutClassic,
            [Events.regStep2]: [Projects.mobile_com, Projects.cupis, Projects.mobile],
            [Events.regStep3]: [Projects.mobile_com],
            [Events.promoEnter]: defaultSettings,
            [Events.regButtonEnter]: defaultSettings,
            [Events.smsCodeEntered]: withoutClassic,
            [Events.smsCodeRepeat]: defaultSettings,
            [Events.selectPhoneVerificationMethod]: defaultSettings,
            [Events.enteredCharInVerificationMethod]: defaultSettings,
            [Events.flashCallRequest]: defaultSettings,
            [Events.flashCallCodeEntered]: defaultSettings,
            [Events.flashCallCodeRepeat]: defaultSettings,
            [Events.backStep]: defaultSettings,
            [Events.registrationDone]: withoutClassic,
            [Events.enteredPhone]: withoutClassic,
            [Events.enteredEmail]: [Projects.desktop, Projects.mobile_new],
            [Events.choseCountry]: withoutClassic,
            [Events.choseCurrency]: [Projects.desktop, Projects.mobile_new, Projects.zenitbet, Projects.mobile_com],
            [Events.enteredPassword]: withoutClassic,
            [Events.enteredRepeatPassword]: [Projects.zenitbet, Projects.mobile_com, Projects.desktop, Projects.mobile_new],
        },
        [Types.authorization]: {
            [Events.authStart]: withoutClassic,
            [Events.authorizationDone]: withoutClassic,
            [Events.logout]: defaultSettings,
            [Events.clickForgotPassword]: defaultSettings,
        },
        [Types.identification]: {
            [Events.identificationStart]: cupisProjects,
            [Events.identificationButtonEnter]: cupisProjects,
            [Events.identificationDateOfBirthInput]: cupisProjects,
            [Events.identificationDocumentInput]: cupisProjects,
            [Events.identificationLastnameInput]: cupisProjects,
            [Events.identificationMiddlenameInput]: cupisProjects,
            [Events.identificationNameInput]: cupisProjects,
            [Events.identificationPassportInput]: cupisProjects,
            [Events.identificationTypeSelection]: cupisProjects,
        }
    },
    [Topics.payments]: {
        [Types.deposit]: {
            [Events.depositPageShow]: defaultSettings,
            [Events.depositInit]: defaultSettings,
            [Events.depositPageChoice]: defaultSettings,
            [Events.depositInputAmount]: defaultSettings,
        },
        [Types.payout]: {
            [Events.payoutPageShow]: defaultSettings,
            [Events.payoutPageChoice]: defaultSettings,
            [Events.payoutInputAmount]: defaultSettings,
        }
    },
    [Topics.navigation]: {
        [Types.common]: {
            [Events.storiesAction]: defaultSettings,
            [Events.storiesButtonClick]: defaultSettings,
            [Events.viewStoriesV2]: defaultSettings,
            [Events.clickStoriesV2]: defaultSettings,
            [Events.moved404]: defaultSettings,
            [Events.topMoved]: defaultSettings,
            [Events.tabClosed]: defaultSettings,
            [Events.moreMoved]: defaultSettings,
            [Events.searchDone]: defaultSettings,
            [Events.promoCurrentMoved]: withoutClassic,
            [Events.promoActionSelect]: defaultSettings,
            [Events.promoMyCurrentMoved]: withoutClassic,
            [Events.promoActionStepSelect]: withoutClassic,
            [Events.questClickParticipate]: withoutClassic,
            [Events.rulesMoved]: defaultSettings,
            [Events.howMoved]: defaultSettings,
            [Events.accessMoved]: defaultSettings,
            [Events.technicalSupportContacted]: defaultSettings,
            [Events.feedbackMoved]: defaultSettings,
            [Events.feedbackRating]: defaultSettings,
            [Events.onlineChatSupportMoved]: defaultSettings,
            [Events.onlineChatSupportRating]: defaultSettings,
            [Events.affiliateProgramMoved]: defaultSettings,
            [Events.applicationMoved]: withoutClassic,
            [Events.applicationDownload]: withoutClassic,
            [Events.newsMoved]: withoutClassic,
            [Events.newsCategorySelection]: withoutClassic,
            [Events.newsOpened]: withoutClassic,
            [Events.newsButtonClick]: withoutClassic,
            [Events.tableWorldCup]: withoutClassic,
            [Events.pageEntered]: defaultSettings,
        },
        [Types.bk]: {
            [Events.liveTabMoved]: defaultSettings,
            [Events.lineMoved]: defaultSettings,
            [Events.eventViewed]: defaultSettings,
            [Events.favoUrites]: defaultSettings,
            [Events.favouritesLiveMoved]: defaultSettings,
            [Events.favouritesLineMoved]: defaultSettings,
            [Events.scheduleTabMoved]: defaultSettings,
            [Events.sportTypeFiltered]: defaultSettings,
            [Events.timeFiltered]: defaultSettings,
            [Events.exodusFiltered]: defaultSettings,
            [Events.infographicsViewed]: defaultSettings,
            [Events.textographicViewed]: defaultSettings,
            [Events.matchCenterViewed]: defaultSettings,
            [Events.videoViewed]: defaultSettings,
            [Events.openVideoFullScreen]: defaultSettings,
            [Events.statisticViewed]: defaultSettings,
            [Events.resultsLineMoved]: defaultSettings,
            [Events.resultsLiveMoved]: defaultSettings,
            [Events.statsMoved]: [Projects.zenitbet, Projects.desktop, Projects.cupis],
        },
        [Types.casino]: {
            [Events.casinoMoved]: defaultSettings,
            [Events.twainSportMoved]: defaultSettings,
            [Events.betgamesMoved]: defaultSettings,
            [Events.liveCasinoMoved]: defaultSettings,
            [Events.casinoGameMoved]: defaultSettings,
            [Events.tvgamesMoved]: defaultSettings,
            [Events.clickCasinoBanner]: defaultSettings,
            [Events.searchCasino]: defaultSettings,
            [Events.cancelSearchCasino]: defaultSettings,
            [Events.favouritesCasinoMoved]: defaultSettings,
            [Events.favouritesCasino]: defaultSettings,
            [Events.casinoGroupSelect]: defaultSettings,
            [Events.casinoCategorySelect]: defaultSettings,
            [Events.casinoProviderSelect]: defaultSettings,
        },
        [Types.toto]: {
            [Events.totoMoved]: defaultSettings,
        },
        [Types.payments]: {
            [Events.historyAllMoved]: defaultSettings,
            [Events.historyAllMoved]: defaultSettings,
            [Events.historyDepositMoved]: mobileProjects,
            [Events.historyPayoutMoved]: mobileProjects,
            [Events.historyPeriodSelect]: defaultSettings,
        },
        [Types.wagers]: {
            [Events.allBetsMoved]: defaultSettings,
            [Events.basketMoved]: mobileProjects,
            [Events.unassignedMoved]: defaultSettings,
            [Events.betTypeSelect]: defaultSettings,
        },
        [Types.promo]: {
            [Events.clickModal]: defaultSettings,
            [Events.viewModal]: defaultSettings,
            [Events.clickModalV2]: defaultSettings,
            [Events.viewModalV2]: defaultSettings,
            [Events.clickBannerBasket]: [Projects.desktop, Projects.zenitbet],
            [Events.clickBanner]: defaultSettings,
            [Events.viewPopUp]: defaultSettings,
            [Events.PL_event_banner]: defaultSettings,
            [Events.PL_event_lenta]: defaultSettings,
            [Events.PL_event_lk]: defaultSettings,
            [Events.PL_event_promo]: defaultSettings,
            [Events.PL_event_story]: defaultSettings
        },
        [Types.Euro24]: {
            [Events.Euro24_move]: defaultSettings,
            [Events.Euro24_tab_move]: defaultSettings
        }
    },
    [Topics.wagers]: {
        [Types.bk]: {
            [Events.eventAdd]: defaultSettings,
            [Events.clickSaleBet]: defaultSettings,
            [Events.confirmSaleBet]: defaultSettings,
            [Events.wagerDone]: defaultSettings,
            [Events.eventDeleted]: defaultSettings,
            [Events.basketCleared]: defaultSettings,
        },
    },
    [Topics.other]: {
        [Types.settings]: {
            [Events.nightTheme]: defaultSettings,
            [Events.basketClearChanged]: defaultSettings,
            [Events.balanceClearChanged]: defaultSettings,
            [Events.sortingChanged]: defaultSettings,
            [Events.coefficientAgreementChanged]: defaultSettings,
            [Events.emailRegularChanged]: defaultSettings,
            [Events.emailImportantChanged]: defaultSettings,
            [Events.smsImportantChanged]: defaultSettings,
            [Events.eventsNumberChanged]: defaultSettings,
            [Events.timezoneChanged]: defaultSettings,
            [Events.fastWagerBasketChanged]: defaultSettings,
            [Events.languageNotificationChanged]: defaultSettings,
            [Events.languageChanged]: defaultSettings,
            [Events.oneClickBetChanged]: [Projects.zenitbet, Projects.desktop],
        },
    },
};



// WEBPACK FOOTER //
// ./src/web-frontend-core/utils/KafkaLogger/KafkaEventsMap.js